import { render, staticRenderFns } from "./IconNear.vue?vue&type=template&id=7e2ffe04&"
import script from "./IconNear.vue?vue&type=script&lang=js&"
export * from "./IconNear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports